import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getExamsAvailableTimes} from '../../services/getExamsAvailableTimes';
import {UseGetExamsMultiAvailableTimesQueryProps} from './types';
import {throwIfAllSettledErrorsAreNot422} from 'presentation/utils/throwIfAllSettledErrorsAreNot422';

export function useGetExamsMultiAvailableTimesQuery({
	params,
	dates,
	enabled,
}: UseGetExamsMultiAvailableTimesQueryProps) {
	return useQuery({
		queryKey: [QUERY_KEYS.EXAMS_AVAILABLE_TIMES, params, dates],
		queryFn: async ({signal}) => {
			const firstThreeDates = dates?.slice(0, 3) ?? [];

			const availableTimes = await Promise.allSettled(
				firstThreeDates?.map(date =>
					getExamsAvailableTimes({
						signal,
						...params,
						dtData: date,
					}),
				),
			);

			throwIfAllSettledErrorsAreNot422(availableTimes);

			const formattedAvailableTimes = availableTimes
				.map((result, index) => ({
					date: firstThreeDates[index],
					times: result.status === 'fulfilled' ? result.value : [],
				}))
				.filter(item => item.times.length > 0);

			return formattedAvailableTimes;
		},
		retry: 1,
		enabled,
		staleTime: 0,
		gcTime: 0,
	});
}
